import React from 'react'
import classnames from 'classnames/bind'

import CirclePicture from 'components/shared/CirclePicture'
import Image from 'components/shared/Image'
import { Text } from 'components/typo'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export default function Person({
  className,
  image,
  name,
  description,
  companyLogo,
  isNameBlue,
  isSimpleCard
}) {
  return (
    <div className={cx(css.Person, className)}>
      {image && image.media && (
        <CirclePicture
          className={cx(css.picture, {
            [css.isSimpleCardLogo]: isSimpleCard
          })}
          picture={{ ...image, format: 'thumbnail' }}
        />
      )}
      <div className={css.content}>
        <span className={css.infos}>
          {name && (
            <Text
              className={cx({
                [css.name]: !isSimpleCard,
                [css.nameSimpleCard]: isSimpleCard,
              })}
              tag="span"
              size="smaller"
              theme={isNameBlue ? 'blue' : 'purple'}
            >
              {name}
            </Text>
          )}
          {description && (
            <Text
            className={cx({
              [css.jobCompany]: !isSimpleCard,
              [css.jobCompanySimpleCard]: isSimpleCard,
            })}
              tag="span"
              size="smaller"
              theme="gray"
            >
              {`${name ? ', ' : ''}${description}`}
            </Text>
          )}
        </span>
        {companyLogo && <Image className={css.companyLogo} {...companyLogo} />}
      </div>
    </div>
  )
}
